import React, {useEffect, useState} from "react";
import PlaidItemDetailsView from "./PlaidItemDetailsView";
import {AppState} from "../../../../../core/commons/reduxStore";

import {updateBankAccountInStoreAction} from "../../../../../core/actions/dashboard/users/updateBankAccountDetailsInStore";
import {connect} from "react-redux";
import {message} from "antd";

const BankAccountPlaid : React.FC<any> = (props: any) => {

    const [isSpinning, setSpinning] = useState(false);

    const onSuccess = () =>{
        message.success('Bank account details loaded successfully!');
        setSpinning(false);
    };

    const onFailure = () => {
        message.info('Bank account details failed to load!');
        setSpinning(false);
    };


    const reload = () => {
        setSpinning(true);
        props.updateBankAccountInStoreAction(props.userId, onSuccess, onFailure);
    };

    useEffect(() => {
        props.updateBankAccountInStoreAction(props.userId, onSuccess, () => {});
    }, []);



    return (<>
        {
            props.bankAccountDetails?.item  != null
                ? <PlaidItemDetailsView
                    details={props.bankAccountDetails}
                    spinning={isSpinning}
                    reload={reload}
                    title={'Plaid Item: Bank Account Details '}/>
                : null
        }
    </>);
}

const mapStateToProps = ({ bankAccountDetails }: AppState) =>
    ({
        bankAccountDetails: bankAccountDetails
    });

export default connect(mapStateToProps, {
    updateBankAccountInStoreAction
})(BankAccountPlaid);